import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoFigma = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 95 48"
    {...props}
  >
    <g
      fill="currentColor"
      clipPath="url(#Logo_Figma_svg__a)"
    >
      <path
        d="M.615 8v26.531l3.394.013V21.911h8.16v-3.343H3.996V11.33h10.64V8zm20.106 5.396a2.2 2.2 0 0 0 1.569-.655 2.247 2.247 0 0 0 0-3.165 2.21 2.21 0 0 0-3.139 0 2.247 2.247 0 0 0 0 3.165c.416.419.98.655 1.57.655m-1.71 3.33v17.818h3.394V16.725z" />
      <path
        fillRule="evenodd"
        d="M34.951 16.212c-4.491 0-7.625 3.83-7.625 8.383 0 4.554 3.134 8.383 7.625 8.383 2.063 0 3.76-.79 5-2.105v2.369a5.4 5.4 0 0 1-1.528 3.825 5.276 5.276 0 0 1-3.772 1.597c-1.084 0-2.154-.422-3.003-1.027l-1.697 2.961a8.626 8.626 0 0 0 8.872.332 8.7 8.7 0 0 0 3.312-3.224 8.8 8.8 0 0 0 1.21-4.478v-16.49h-3.394v1.593c-1.24-1.316-2.937-2.106-5-2.106zm-4.243 8.383c0-2.83 2.141-5.053 4.622-5.053s4.608 2.237 4.608 5.053c0 2.83-2.14 5.04-4.608 5.04-2.48 0-4.622-2.21-4.622-5.04"
        clipRule="evenodd"
      />
      <path
        d="M55.54 19.542c-.971.017-1.896.419-2.575 1.118a3.74 3.74 0 0 0-1.055 2.62v11.264h-3.394V16.726h3.394v1.632a5.36 5.36 0 0 1 1.925-1.599 5.3 5.3 0 0 1 2.436-.546c2.376 0 4.204 1.185 5.248 3a6.5 6.5 0 0 1 2.321-2.184 6.46 6.46 0 0 1 3.071-.816c3.851 0 6.267 3.132 6.267 7.015v11.317h-3.369V23.267a3.74 3.74 0 0 0-1.054-2.619 3.68 3.68 0 0 0-2.575-1.118 3.68 3.68 0 0 0-2.575 1.118 3.74 3.74 0 0 0-1.055 2.62V34.53h-3.394V23.266a3.74 3.74 0 0 0-1.05-2.614 3.68 3.68 0 0 0-2.566-1.123z" />
      <path
        fillRule="evenodd"
        d="M91.234 18.752a8.2 8.2 0 0 0-2.724-1.89 8.1 8.1 0 0 0-3.243-.65c-5.04 0-8.617 4.29-8.617 9.423 0 5.132 3.578 9.423 8.617 9.423a8.2 8.2 0 0 0 3.242-.653 8.2 8.2 0 0 0 2.725-1.887v2.026h3.38V16.726H91.22v2.027zm-11.202 6.883c0-3.396 2.585-6.093 5.6-6.093 3.003 0 5.602 2.697 5.602 6.093s-2.585 6.08-5.601 6.08c-3.003 0-5.601-2.685-5.601-6.08"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Logo_Figma_svg__a">
        <path
          fill="#fff"
          d="M.615 0h94v48h-94z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoFigma;
